import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  width: "310",
  height: "190",
  viewBox: "0 0 310 190",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<rect width=\"310\" height=\"190\" fill=\"url(#paint0_radial_487_841)\" fill-opacity=\"0.08\"></rect><defs><radialGradient id=\"paint0_radial_487_841\" cx=\"0\" cy=\"0\" r=\"1\" gradientUnits=\"userSpaceOnUse\" gradientTransform=\"translate(46 49) rotate(29.8112) scale(323.828 311.568)\"><stop stop-color=\"var(--dt-color-purple-300)\"></stop><stop offset=\"0.770833\" stop-color=\"var(--dt-color-blue-400)\" stop-opacity=\"0.33\"></stop><stop offset=\"1\" stop-color=\"var(--dt-color-green-200)\" stop-opacity=\"0.22\"></stop></radialGradient></defs>", 2)
  ]))]))
}
export default { render: render }